export const SORTING_ITEMS = ['-is_hit', '-is_new', 'price', '-price'];
